import { render, staticRenderFns } from "./contingency2.vue?vue&type=template&id=516bca1a&scoped=true&"
import script from "./contingency2.vue?vue&type=script&lang=js&"
export * from "./contingency2.vue?vue&type=script&lang=js&"
import style0 from "./contingency2.vue?vue&type=style&index=0&id=516bca1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516bca1a",
  null
  
)

export default component.exports